module.exports = __webpack_public_path__ + "static/media/src1.b8ff99e3.jpg";